import { event } from '../../models/entities/common_subentities/event';

type ShipmentWithAta = {
    ata?: Date | string | null;
    events?: event[];
};

/** Same ATA resolution as shipment overview: DB column, else latest ARRIVAL event. */
export function resolveShipmentAta(shipment: ShipmentWithAta): Date | string | undefined {
    if (shipment.ata) {
        return shipment.ata;
    }

    return shipment.events
        ?.filter((item) => item.eventCode === 'ARRIVAL')
        .sort((a, b) => new Date(b.eventDate).getTime() - new Date(a.eventDate).getTime())[0]?.eventDate;
}
